import Vue from 'vue'
import Vuex from 'vuex'
import ajax from '@/utils/http'

// vuex 持久化插件（原理：将数据保存在session中一份）
import persistedState from "vuex-persistedstate"

Vue.use(Vuex);

const store = new Vuex.Store({

    plugins: [persistedState({storage: window.sessionStorage})],
    state: {
        userInfo: {},
        isLogin: true
    },
    mutations: {
        setUserInfo(state, data) {
            state.userInfo = {...state.userInfo, ...data};
            console.log(state.userInfo, data);
        }
    },
    actions: {
        getUserInfo(context) {
            return ajax.get('/appapi/user/getUserInfo').then((res) => {
                if (res.data.code === 1) {
                    let data = res.data.data;
                    data.isLogin = true;
                    context.commit('setUserInfo', data)
                }
            })
        }
    }
});

export default store
